import { IBankAccountChangeViewModel } from '../types/bankAccountChangeViewModel'

export class BankAccountChangeViewModel implements IBankAccountChangeViewModel
{
    effectiveDate: Date = undefined
    isNewEffectiveDate: boolean = false
    leaseNumber: string = ''
    make: string = ''
    oemId: number = 0
    customerAccountType: number = 0
    isActiveLease: boolean = false
    hasExistingBankAccountChangeRequest: boolean = false
    existingBankAccountChangeRequestId: string = ''
    referenceNumber: string = ''
}